import {helloWorldTutorial} from './definitions/helloWorldTutorial';
import {powerUserTutorial} from './definitions/powerUserTutorial';

export const TUTORIALS = [
    helloWorldTutorial,
    powerUserTutorial,
];
